import React from 'react';
import { ButtonTheme, ModalTheme, RenderForm } from '../../../../components';
import { TextLarge } from '../../../../components/text';
import { ContainerButton } from '../../../../styles/global-style';
import { FORM_CLAIM_UPDATE_PRODUCT } from '../form';
import { useUpdateProductForm } from '../hooks/useUpdateProductForm';
import { Spin } from 'antd';

export const UpdateProductModal = ({ open, onToggle, claimData }) => {
  const {
    control,
    setValue,
    getValues,
    mobileBrandOptions,
    mobileRowCount,
    onEnterBarcode,
    onBarcodeChange,
    onSelectProduct,
    productOptions,
    onSubmit,
    loading,
  } = useUpdateProductForm({ claimData });

  return (
    <ModalTheme title=" " open={open} onToggle={onToggle}>
      <Spin spinning={loading}>
        <div style={{ width: '100%', textAlign: 'left' }}>
          <TextLarge text="เปลี่ยนสินค้า" />
        </div>
        <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FORM_CLAIM_UPDATE_PRODUCT({
            onEnter: onEnterBarcode,
            onBarcodeChange,
            onSelectProduct,
            productOptions,
            mobileBrandOptions,
            mobileRowCount,
          })}
        />
        <ContainerButton right>
          <ButtonTheme useFor="SUBMIT" onClick={onSubmit} />
          <ButtonTheme useFor="CANCEL" onClick={onToggle} />
        </ContainerButton>
      </Spin>
    </ModalTheme>
  );
};
